import React from "react";
import "./downloadbanners.css";

const DownloadBanners = () => {
  return (
    <div>
      <div className="downloadbanners-main">
        <div className="downloadbanners-cards">
          <div className="downloadbanners-card-1">
            <div className="downloadbanners-card-1-top">
              <img src="/assets/bcimages/bcaffiliate/gif1.gif" />
              <img className="img2" src="/assets/bcimages/bcaffiliate/gif2.gif" />
              <img className="img3" src="/assets/bcimages/bcaffiliate/gif3.gif" />
            </div>
            <div className="downloadbanners-card-1-bottom">
              <div className="card-1-bottom-title">Banner Pack</div>
              <div className="card-1-bottom-subtitle">
                Multilingual Package including events, animated banners, and
                more...
              </div>
              <a
              className="card-1-bottom-button"
                rel="noopener noreferrer"
                target="_blank"
                href="https://drive.google.com/drive/folders/1Q48CUgrJOAeDGpBqmdHGNwWGxNEdTZzQ?usp=sharing"
              >
                <button type="button">
                  <span>Download (200MB)</span>
                  <svg fill="" width="20" height="20" viewBox="0 0 32 32">
                    <path d="M25.1756 11.9253H19.742V3.7749H11.5916V11.9253H6.15796L15.6668 22.7925L25.1756 11.9253ZM4.79956 25.5093H26.534V28.2261H4.79956V25.5093Z"></path>
                  </svg>
                </button>
              </a>
            </div>
          </div>
          <div className="downloadbanners-card-1">
            <div className="downloadbanners-card-1-top">
              <img className="download-banners-img" src="/assets/bcimages/bcaffiliate/download-banners.webp" />
            </div>
            <div className="downloadbanners-card-1-bottom">
              <div className="card-1-bottom-title">Graphics Pack</div>
              <div className="card-1-bottom-subtitle">
              Web design components including Coco, logo, gaming elements, and UI Assets
              </div>
              <a
              className="card-1-bottom-button"
                rel="noopener noreferrer"
                target="_blank"
                href="https://drive.google.com/drive/folders/1Q48CUgrJOAeDGpBqmdHGNwWGxNEdTZzQ?usp=sharing"
              >
                <button type="button">
                  <span>Download (22.2MB)</span>
                  <svg fill="" width="20" height="20" viewBox="0 0 32 32">
                    <path d="M25.1756 11.9253H19.742V3.7749H11.5916V11.9253H6.15796L15.6668 22.7925L25.1756 11.9253ZM4.79956 25.5093H26.534V28.2261H4.79956V25.5093Z"></path>
                  </svg>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadBanners;
